import React from 'react';

export function getItemCategory(item, itemType) {
  if (!item) return undefined;
  if (item.teachesRecipeForItemId ?? item.TeachesRecipeForItemId) return 'recipe';
  if (!itemType) return undefined;
  if (itemType.isConsumable ?? itemType.IsConsumable) return 'consumable';
  if (itemType.isEquipment ?? itemType.IsEquipment) return 'equipment';
  if (String(itemType.name ?? itemType.Name).toLowerCase() === 'material') return 'material';
  return undefined;
}

export default function ItemSlot({
  as: Component = 'div',
  className = '',
  item,
  itemType,
  rarity,
  rarityColor,
  selected,
  style,
  ...props
}) {
  return (
    <Component
      className={`pl-item-slot ${className}`.trim()}
      data-item-category={getItemCategory(item, itemType)}
      data-rarity={rarity || undefined}
      data-selected={selected || undefined}
      style={rarityColor ? { ...style, '--pl-item-rarity-color': rarityColor } : style}
      {...props}
    />
  );
}
